const en = {
    loading: "Loading...",
    list: "List",
    new: "New",
    yes: "Yes",
    no: "No",

    switch_on: 'On',
    switch_off: 'Off',
    yes: 'Yes',
    no: 'No',
    n_of_k: "{n} of {k}",
    please_wait: "Working...",

    storage_policy_mgmt: {
      replicas: 'replicas'
    },

    errors: {
      server_error: "Server error",
      generic: "An error occurred, please try again a bit later"
    },

    pages: {
      pages: "Pages",
      dashboard: "Dashboard",

      storage_policies_list: "List Policies",
      storage_policy_details: "Policy Details",
      storage_policy_create: "New Policy",
      storage_policy_create_serrano: "New Declarative Policy",
      storage_policy_edit: "Edit Policy",
      storage_locations: "Storage Locations",
      location_catalog_locations: "Storage Locations",
      location_catalog_carbon_emissions: "Carbon Emissions",

      api_key_list: "List API Keys",
      api_key_details: "API Key Details",
      api_key_create: "New API Key",
      agents: "Agent Connections",
      s3_access_keys: "S3 Access Keys",
      access_policies: "Access Policies",

      buckets_list: "List Buckets",
      buckets: "Buckets",
      storage_policies: "Storage Policies",
      location_catalog: "Location Catalog",
      bucket_details: "Bucket Details",
      bucket_create: "New Bucket",

      profile_settings: "Profile Settings",

      docs: "Documentation",

      empyrean_associations_list: "List Associations",
      empyrean_associations_create: "New Association",
      empyrean_associations_join: "Join Association",

    },

    menu: {
      storage: "Storage",
      storage_policy: "Storage Policies",
      location_catalog: "Location Catalog",
      api_keys: "API Keys",
      access: "Access",
      buckets: "Buckets",
      docs: "Documentation",
      empyrean: {
        associations: "Associations"
      }
    },

    // Page descriptions shown under the page title, referenced by the
    // router's `meta.pageDescription`. {brand} is the brand display name.
    page_descriptions: {
      buckets: "Your S3 buckets, the storage policy each one uses, and how much data they hold.",
      bucket_create: "Create an S3 bucket and choose the storage policy that decides where its data is stored.",

      storage_policies: "Named storage configurations for buckets.",
      storage_policy_create: "Choose the redundancy and shard locations for your data.",
      storage_policy_edit: "Change the redundancy and shard locations of this storage policy.",

      agents: "Connect AI agents or agent-enabled applications to the {brand} MCP server through an authorized connection.",
      agent_create: "Set up an AI agent or application to access your storage through the {brand} MCP server.",
      api_keys: "Access keys for S3-compatible tools, SDKs and applications to work with your buckets.",
      api_key_create: "Create an access key for an S3-compatible tool, SDK or application.",
      access_policies: "Bucket permissions granted to your connected agents.",

      location_catalog: "Integrated cloud providers and regions, where data shards can be stored redundantly.",

      account_settings: "",
      profile_settings: "",
      team_setup: "Invite your colleagues and name your team!",
      upgrade: "Upgrade to remove the storage limit!",

      associations: "Associations connect organizations that share storage gateways and edge storage devices on a common network.",
      association_create: "Create a new association to share storage infrastructure with other organizations.",
      association_join: "Join an existing association using the join key you received.",
    },

    storage_policy_wizard: {
      step1: "Basics",
      step2: "Reliability",
      step3: {
        ec: "Shard Locations",
        replication: "Replica Locations"
      },
      step4: "Bucket Defaults",
      step5: "Summary",

      policy_name: "Name",
      description: "Description",
    },

    apikey_wizard: {
      step1: "Config",
      step2: "Summary",

      description: "Description",
    },

    redundancy_schemes: {
      ec: "Erasure Coding",
      ec_desc: "Balances performance and cost by encoding objects into redundant data fragments which are distributed across multiple locations.",

      replication: "Replication",
      replication_desc: "Store multiple full copies of objects."
    },

    bucket_download_strategies: {
      fastest: { // key from the DB
        name: "Fastest",
        description: "Prefer fragments that are fastest to retrieve, based on recent transfers"
      },
      closest: {
        name: "Greenest",
        description: "Prefer fragments closest to the server handling the download"
      },
      cheapest: {
        name: "Cheapest",
        description: "Prefer fragments at storage locations with lowest egress cost"
      },
      default: {
        name: "Default",
        description: "-"
      }
    },

    adaptive_policy_form: {
      min_fragment_download_speed: "Min Download Speed",
      min_fragment_download_speed_placeholder: "E.g., 21",
      min_fragment_download_speed_unit: "Mbps",
      max_egress_cost: "Max Egress Cost",
      max_egress_cost_placeholder: "E.g., 12.5",
      max_egress_cost_unit: "$/TB",
      max_emissions: "Max Emissions",
      max_emissions_placeholder: "E.g., 180",
      max_emissions_unit: "gCO2eq/kWh",
      greenest_emissions_mode: "Emissions Mode",
      greenest_emissions_mode_help: "Physical uses actual emissions. Market-adjusted subtracts purchased carbon-free electricity. This mode is used for both optimization and the max emissions limit.",
      greenest_emissions_mode_options: {
        physical: {
          label: "Physical",
        },
        market_adjusted: {
          label: "Market-adjusted",
        }
      },
      gdpr_everywhere: "GDPR Everywhere",
      gdpr_everywhere_help: "When turned on, every cloud provider is limited to less than 100% of data.",
      regional_outage_resilience: "Regional Outage Resilience",
      regional_outage_resilience_help: "Avoids placing too many fragments close to each other.",
      geofence: "Geofence",
      geofence_help: "Restrict data fragments to specific countries.",
      geofence_placeholder: "Select countries",
      optimization_strategy: "Optimization Strategy",
      optimization_options: {
        cheapest: { label: "Cheapest", desc: "Lowest egress cost" },
        closest: { label: "Closest", desc: "Shortest distance" },
        fastest: { label: "Fastest", desc: "Fastest download" },
        greenest: { label: "Greenest", desc: "Lowest emissions" },
        custom: { label: "Custom", desc: "Fine-tune weights" }
      },
      optimization_distance: "Distance",
      optimization_distance_change: "Distance importance",
      optimization_speed: "Speed",
      optimization_speed_change: "Speed importance",
      optimization_cost: "Cost",
      optimization_cost_change: "Cost importance",
      optimization_greenest: "CO Emission",
      optimization_greenest_change: "Carbon emission importance",


      description: "Description",
      description_placeholder: "Optional",
      cancel: "Cancel",
      update_policy: "Update Policy",
      save_policy: "Save Policy",
      save_error: "Error saving bucket policy"
    },

    languages: {
      label: "Languages",
      en: "English",
      dk: "Danish",
      de: "German"
    },

    continents: {
      europe: "Europe",
      "north-america": "North America",
      "south-america": "South America",
      asia: "Asia",
      australia: "Australia",
      "middle-east": "Middle East",
      africa: "Africa",
    },

    associations: {

      gateway: {
        name: "Gateway",
        description: "Storage servers that provide the S3 object storage API on the Association's internal network and have access to the local Edge Storage devices.",

        fields: {
          name: "Name",
          name_placeholder: "Display name",
          name_column: "Gateway Name",
          desc: "Description",
          desc_placeholder: "Optional",
          online_status: 'Status',
          url: "URL",
          url_placeholder: "Address where the Gateway is available on the Association network",
          access_keys: "Access Keys"
        }
      },

      edge_storage: {
        name: "Edge Storage",
        description: "MinIO server instance that stores encrypted data fragments",

        fields: {
          name: "Name",
          name_placeholder: "Display name",
          name_column: "Edge Storage Name",
          desc: "Description",
          desc_placeholder: "Optional",
          storage_url: "S3 API Base URL",
          storage_url_placeholder: "Address where Gateways can reach this Edge Storage on the Association network",
          access_key: "Access Key",
          access_key_placeholder: "Credentials used by the Gateway",
          secret_key: "Secret Key",
          secret_key_placeholder: "Credentials used by the Gateway",
        }
      }

    },

    auth: {
      signIn: "Sign In",
      signUp: "Sign-up",
      email_label: "Email",
      pass_label: "Password",
      forgot_pass_link: "Forgot password?",
      login_btn: "Login",


      errors: {
        heading: "Login Failed!",
        no_password: "Password missing",
        user_not_found: "Wrong email or password!",
        wrong_mfa_code: "Wrong code!",
        mfa_rate_limit: "Too many wrong codes, you can try again in {seconds} seconds!",
        password_reset_invalid: "Password reset request is invalid or expired.",
        unauthorized: "Login failed!",
        generic: "Login failed!"
      }
    },



    dashboard: "Dashboard",
    layoutBuilder: "Layout builder",
    craft: "Crafted",
    profile: "Profile",
    profileOverview: "Overview",
    projects: "Projects",
    campaigns: "Campaigns",
    documents: "Documents",
    connections: "Connections",
    wizards: "Wizards",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Account",
    accountOverview: "Overview",
    settings: "Settings",
    authentication: "Authentication",
    basicFlow: "Basic Flow",

    passwordReset: "Password Reset",
    multiStepSignUp: "Multi-steps Sign up",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Apps",
    chat: "Chat",
    privateChat: "Private Chat",
    groupChat: "Group Chat",
    drawerChat: "Drawer Chat",
    widgets: "Widgets",
    widgetsLists: "Lists",
    widgetsStatistics: "Statistics",
    widgetsCharts: "Charts",
    widgetsMixed: "Mixed",
    widgetsTables: "Tables",
    widgetsFeeds: "Feeds",
    changelog: "Changelog",
    docsAndComponents: "Docs & Components",
    megaMenu: "Mega Menu",
    exampleLink: "Example link",
    modals: "Modals",
    general: "General",
    inviteFriends: "Invite Friends",
    viewUsers: "View Users",
    upgradePlan: "Upgrade Plan",
    shareAndEarn: "Share & Earn",
    forms: "Forms",
    newTarget: "New Target",
    newCard: "New Card",
    newAddress: "New Address",
    createAPIKey: "Create API Key",
    twoFactorAuth: "Two Factor Auth",
    createApp: "Create App",
    createAccount: "Create Account",
    documentation: "Documentation",
    components: "Components",
    resources: "Resources",
    activity: "Activity",
    customers: "Customers",
    gettingStarted: "Getting Started",
    customersListing: "Customers Listing",
    customerDetails: "Customers Details",
    calendarApp: "Calendar",
    subscriptions: "Subscriptions",
    getStarted: "Getting Started",
    subscriptionList: "Subscription List",
    addSubscription: "Add Subscription",
    viewSubscription: "View Subscription",
  }

export default en
